import { Box, BoxProps } from '@mui/material';
import { NAV } from 'src/config-global';

export function LayoutMainContainer({
  children,
  sx,
  blankPage,
  ...other
}: BoxProps & { blankPage?: boolean }) {
  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        maxWidth: '100%',
        overflowX: 'hidden',
        ...(blankPage
          ? {
              width: `calc(100% - ${NAV.W_DASHBOARD_COLLAPSED}px)`,
            }
          : {}),
        p: 0,
        position: 'relative',
        zIndex: 0,
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
